module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMTIgNiI+PHBhdGggZD0iTTAgMGgxMnY2SDB6Ii8+PHBhdGggZmlsbD0iI0ZGRiIgZD0iTTAgMGgxMnY0SDB6Ii8+PHBhdGggZmlsbD0iI0QyMTAzNCIgZD0iTTAgMGgxMnYySDB6Ii8+PHBhdGggZmlsbD0iIzAwNzIyOSIgZD0iTTAgMGw0IDMtNCAzeiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/sdn.svg
// module id = YqQg
// module chunks = 0